import { RenderCellProps } from '@/components/cashflow/transactions/TableRow';
import { ChevronRight } from '@/components/common/icons';
import { groupHoverStyleProps } from '@/components/common/styleHelpers';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ViewTransactionCell = (props: RenderCellProps) => (
    <ChevronRight
        color="gray.500"
        size="sm"
        data-cy="view-transaction"
        mt={1.5}
        {...groupHoverStyleProps({
            color: 'blue.500',
        })}
    />
);

export default ViewTransactionCell;
